import React from "react"
import { useTranslation } from "react-i18next"

import { formatMobilePhone, scale } from "utils"

const PloptfcustomerCustomerDetails = (props) => {
  const { templateType, printData, printerWidth } = props

  const {
    deliveryType,
    address,
    accountRole,
    customerFullName,
    customerMobilePhone
  } = printData

  const [t, i18n] = useTranslation()

  const dir = i18n.dir(i18n.language)

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth, dir)
      : stylesOthers(dir)

  const removeBorderBottom =
    !!customerMobilePhone &&
    !!customerFullName

  if (accountRole !== "user") return null

  return (
    <div style={styles["container"]}>
      {
        !!customerMobilePhone &&
        <div style={{ ...styles["phone"], ...(removeBorderBottom ? { borderBottom: 0 } : {}) }}>
          <div style={styles["text4"]}>
            {t("تلفن")}
          </div>
          <div style={styles["text7"]}>
            {formatMobilePhone(customerMobilePhone)}
          </div>
        </div>
      }

      {
        !!customerFullName &&
        <div style={styles["phone"]}>
          <div style={styles["text4"]}>
            {t("نام مشتری")}
          </div>
          <div style={styles["text7"]}>
            {customerFullName}
          </div>
        </div>
      }

      {
        deliveryType === "delivery" &&
        <div style={styles["address"]}>
          <div style={styles["addressItem"]}>
            <div style={styles["text4"]}>
              {t("آدرس")}
            </div>
            <div style={styles["text7"]}>
              {address.address}
            </div>
          </div>
          <div style={styles["addressItem"]}>
            <div style={styles["text4"]}>
              {t("کدپستی")}
            </div>
            <div style={styles["text7"]}>
              {address.zipCode}
            </div>
          </div>
          {
            !!address.note &&
            <div style={styles["addressItem"]}>
              <div style={styles["text4"]}>
                {t("یادداشت")}
              </div>
              <div style={styles["text7"]}>
                {address.note}
              </div>
            </div>
          }
        </div>
      }
    </div>
  )
}

const stylesThermal = (printerWidth, dir = "rtl") => ({
  container: {
    fontSize: scale("19px", printerWidth),
    paddingTop: scale("10px")
  },

  phone: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    borderBottom: `${scale("2px")} solid`,
    [dir === "rtl" ? "borderLeft" : "borderRight"]: `${scale("2px")} solid`
  },

  text4: {
    flex: 1,
    textAlign: "center",
    [dir === "rtl" ? "borderRight" : "borderLeft"]: `${scale("2px")} solid`,
    borderTop: `${scale("2px")} solid`
  },

  text7: {
    flex: 1,

    textAlign: "center",
    [dir === "rtl" ? "borderRight" : "borderLeft"]: `${scale("2px")} solid`,
    borderTop: `${scale("2px")} solid`
  },

  addressItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },

  address: {
    marginTop: scale("20px"),
    borderBottom: `${scale("2px")} solid`,
    [dir === "rtl" ? "borderLeft" : "borderRight"]: `${scale("2px")} solid`
  }
})

const stylesOthers = (dir = "rtl") => ({
  container: {
    marginRight: "8px",
    paddingTop: "4px",
    fontSize: "11px"
  },


  phone: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    borderBottom: "1px solid",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "1px solid"
  },

  text4: {
    flex: 1,
    textAlign: "center",
    [dir === "rtl" ? "borderRight" : "borderLeft"]: "1px solid",
    borderTop: "1px solid"
  },

  text7: {
    flex: 1,
    textAlign: "center",
    [dir === "rtl" ? "borderRight" : "borderLeft"]: "1px solid",
    borderTop: "1px solid"
  },

  address: {
    marginTop: "5px",
    borderBottom: "1px solid",
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "1px solid"
  },

  addressItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  }
})

export default PloptfcustomerCustomerDetails